var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowGray = function SvgArrowGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9393A7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6H0M17 11l5-5-5-5"
  }))));
};
export { SvgArrowGray as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyMyAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDQiPgo8ZyBpZD0iR3JvdXAgMyI+CjxwYXRoIGlkPSJTdHJva2UgNDI4NSIgZD0iTTIyIDZIMCIgc3Ryb2tlPSIjOTM5M0E3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlN0cm9rZSA0Mjg2IiBkPSJNMTcgMTFMMjIgNkwxNyAxIiBzdHJva2U9IiM5MzkzQTciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";